import { render } from "./termsView.vue?vue&type=template&id=fb42e8ae&scoped=true"
import script from "./termsView.vue?vue&type=script&lang=js"
export * from "./termsView.vue?vue&type=script&lang=js"

import "./termsView.vue?vue&type=style&index=0&id=fb42e8ae&scoped=true&lang=css"
import "./termsView.vue?vue&type=style&index=1&id=fb42e8ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb42e8ae"]])

export default __exports__